import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder d-flex align-items-center text-dark" }, [
  /*#__PURE__*/_createTextVNode(" Subject Details "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Reseach Subject details"
  })
], -1)
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, "1. How many subjects do you plan to enroll? ", -1)
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, "2. What is the age range of your targeted population (e.g., general adult population is 18+)", -1)
const _hoisted_10 = { class: "mb-6 d-flex flex-stack" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6" }, " 3. Does your target population include Gannon University students? ", -1)
const _hoisted_12 = { class: "form-check form-switch form-check-custom form-check-solid mb-6" }
const _hoisted_13 = { class: "form-check-label fw-bold text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_Field, {
            type: "number",
            class: "form-control form-control-solid",
            placeholder: "",
            name: "q1_1",
            modelValue: _ctx.step1.q1_1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step1.q1_1) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "q1_1",
          class: "fv-plugins-message-container invalid-feedback"
        }),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            (_openBlock(), _createBlock(_component_el_select, {
              class: "form-select-solid",
              placeholder: "Select option",
              name: "q1_2",
              "data-control": "q1_2",
              modelValue: _ctx.step1.q1_2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.q1_2) = $event)),
              key: _ctx.step1.q1_2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Minors (less than 18 years of old)",
                  value: "Minors (less than 18 years of old)"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Minors (less than 18 years of old)")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Adults (18 years and above)",
                  value: "Adults (18 years and above)"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Adults (18 years and above)")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Seniors (65 years and above)",
                  value: "Seniors (65 years and above)"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Seniors (65 years and above)")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Others, please specify",
                  value: "Others, please specify"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Others, please specify")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          ])
        ]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "q1_2",
          initialValue: "",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step1.q1_2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.q1_2) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "q1_2",
          class: "fv-plugins-message-container invalid-feedback"
        }),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("label", _hoisted_12, [
            _createVNode(_component_Field, {
              type: "checkbox",
              class: "form-check-input",
              name: "q1_3",
              value: "1",
              modelValue: _ctx.step1.q1_3,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.q1_3) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.step1.q1_3=="1"?"Yes":"No"), 1)
          ])
        ])
      ])
    ])
  ]))
}